import { render, staticRenderFns } from "./addfullactivity.vue?vue&type=template&id=6c52eb84&"
import script from "./addfullactivity.vue?vue&type=script&lang=js&"
export * from "./addfullactivity.vue?vue&type=script&lang=js&"
import style0 from "./addfullactivity.vue?vue&type=style&index=0&id=6c52eb84&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports